module.exports = __webpack_public_path__ + "img/box-by-door.af2b4905.jpg";